import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileViewComponent } from 'src/app/components/profile-view/profile-view.component';
import { ProfileEditComponent } from 'src/app/components/profile-edit/profile-edit.component';
import { ChangePasswordComponent } from 'src/app/components/change-password/change-password.component';

const routes: Routes = [
  {path:"", component:DashboardComponent},
  {path:"profile",component:ProfileViewComponent},
  {path:"edit/profile",component:ProfileEditComponent},
  {path:"change/password",component:ChangePasswordComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InstallerRoutingModule { }
